import clsx, { ClassValue } from 'clsx';
import { Radio, RadioProps, RadioRenderProps } from 'react-aria-components';

import { focusRingStaticClassName } from '#/shared/utils/domHelper';

export type RadioFieldProps = RadioProps & {
  label: string;
  description?: string;
  isError?: boolean;
};

const getOuterCircleBorderClass = ({
  isError,
  isSelected,
  isHovered,
}: Partial<RadioRenderProps> & {
  isError?: boolean;
}): ClassValue => {
  if (isError) {
    return 'border-error';
  } else if (isSelected || isHovered) {
    return 'border-primary-shade';
  }
  return 'border-outline-l4';
};

export const RadioField = ({ description, className, label, value, isError, ...props }: RadioFieldProps) => {
  return (
    <Radio {...props} value={value} className={clsx('w-full', className)}>
      {({ isSelected, isHovered, isFocused }: RadioRenderProps) => (
        <div
          className={clsx(
            'flex items-start',
            'px-12 py-16',
            'rounded-xs border-1',
            isSelected || isHovered ? 'border-primary-shade' : 'border-outline-l4',
            isSelected ? 'bg-primary-surface-l2' : 'bg-surface-l0',
            isHovered ? 'cursor-pointer' : '',
            isFocused ? focusRingStaticClassName : '',
          )}
        >
          {/* Outer circle */}
          <div
            className={clsx(
              'flex items-center justify-center',
              'w-24 h-24 min-w-24',
              'mr-8 my-0',
              'rounded-full border-[1.5px]',
              isError ? 'bg-error-surface-l1' : '',
              getOuterCircleBorderClass({ isError, isSelected, isHovered }),
            )}
          >
            {/* Inner circle */}
            {isSelected && <div className="w-14 h-14 rounded-full bg-primary-shade" />}
          </div>
          <div>
            <div className="text-16 text-on-surface">{label}</div>
            {!!description && <div className="text-14 text-on-surface-variant">{description}</div>}
          </div>
        </div>
      )}
    </Radio>
  );
};
